// ─── Contact Result Options (15 รายการ) ─────────────────────────────────────
export const contactResultOptions = [
  { label: "1) สั่งซื้อ", value: "สั่งซื้อ" },
  { label: "2) สั่งจอง", value: "สั่งจอง" },
  { label: "3) ลูกค้านัดติดต่อใหม่/ยังไม่สะดวกคุย", value: "ลูกค้านัดติดต่อใหม่/ยังไม่สะดวกคุย" },
  { label: "4) ไม่สนใจ_(ระบุสาเหตุ)", value: "ไม่สนใจ_(ระบุสาเหตุ)" },
  { label: "5) ไม่รับสาย/ปิดเครื่อง/ติดต่อไม่ได้", value: "ไม่รับสาย/ปิดเครื่อง/ติดต่อไม่ได้" },
  { label: "6) ไม่รับสายครบ 3 ครั้ง", value: "ไม่รับสายครบ 3 ครั้ง" },
  { label: "7) Complain case", value: "Complain case" },
  { label: "8) Lead ซ้ำ", value: "Lead ซ้ำ" },
  { label: "9) Backlist", value: "Backlist" },
  { label: "10) เบอร์ผิด/เสีย/ตปท.", value: "เบอร์ผิด/เสีย/ตปท." },
  { label: "11) ไม่สนใจ_ห้ามติดต่ออีก(ระบุสาเหตุ)", value: "ไม่สนใจ_ห้ามติดต่ออีก(ระบุสาเหตุ)" },
  { label: "12) สั่งซื้อช่องทางอื่นแล้ว", value: "สั่งซื้อช่องทางอื่นแล้ว" },
  { label: "13) ติดต่อไม่ได้ รอการ Follow Up อีกครั้ง", value: "ติดต่อไม่ได้ รอการ Follow Up อีกครั้ง" },
  { label: "14) Follow Up_Unsuccess_ติดต่อไม่ได้", value: "Follow Up_Unsuccess_ติดต่อไม่ได้" },
  { label: "15) สอบถามทั่วไป", value: "สอบถามทั่วไป" },
];

// ─── Reason Options (21 รายการ) — ใช้เมื่อ result = 4 หรือ 11 ─────────────
export const reasonOptions = [
  { label: "1) โปรโมชั่นไม่ตอบโจทย์_(แถมอะไรระบุ..)", value: "โปรโมชั่นไม่ตอบโจทย์_(แถมอะไรระบุ..)" },
  { label: "2) แพงเกินไป", value: "แพงเกินไป" },
  { label: "3) ไม่พอใจการใช้สินค้า/ใช้แล้วเฉยๆ", value: "ไม่พอใจการใช้สินค้า/ใช้แล้วเฉยๆ" },
  { label: "4) แพ้ผลิตภัณฑ์", value: "แพ้ผลิตภัณฑ์" },
  { label: "5) ไม่พอใจการจัดส่ง", value: "ไม่พอใจการจัดส่ง" },
  { label: "6) ไม่ประทับใจการบริการ", value: "ไม่ประทับใจการบริการ" },
  { label: "7) ไม่ได้ใช้สินค้าเอง(ซื้อแทน)", value: "ไม่ได้ใช้สินค้าเอง(ซื้อแทน)" },
  { label: "8) ไม่เชื่อถือโฆษณา/พรีเซ็นเตอร์", value: "ไม่เชื่อถือโฆษณา/พรีเซ็นเตอร์" },
  { label: "9) ไม่มั่นใจบริษัท", value: "ไม่มั่นใจบริษัท" },
  { label: "10) ไม่สะดวกเรื่องเงิน", value: "ไม่สะดวกเรื่องเงิน" },
  { label: "11) ถ้าสนใจเดี่ยวจะติดต่อมาซื้อเอง", value: "ถ้าสนใจเดี่ยวจะติดต่อมาซื้อเอง" },
  { label: "12) สั่งซื้อสินค้าช่องทางอื่นแล้ว", value: "สั่งซื้อสินค้าช่องทางอื่นแล้ว" },
  { label: "13) ใช้สินค้าแบรนด์อื่นอยู่ ระบุ....", value: "ใช้สินค้าแบรนด์อื่นอยู่ ระบุ...." },
  { label: "14) แพทย์สั่งห้ามรับประทาน / ติดปัญหาสุขภาพ", value: "แพทย์สั่งห้ามรับประทาน / ติดปัญหาสุขภาพ" },
  { label: "15) ผู้ใช้สินค้าเสียชีวิต", value: "ผู้ใช้สินค้าเสียชีวิต" },
  { label: "16) สินค้าเดิมยังไม่หมด", value: "สินค้าเดิมยังไม่หมด" },
  { label: "17) ไม่ได้ใช้สินค้าแล้ว", value: "ไม่ได้ใช้สินค้าแล้ว" },
  { label: "18) ขอคิดดูก่อน/ขอปรึกษาญาติก่อน", value: "ขอคิดดูก่อน/ขอปรึกษาญาติก่อน" },
  { label: "19) ไม่มีไซต์/ไม่มีสี/ไม่มีสินค้า", value: "ไม่มีไซต์/ไม่มีสี/ไม่มีสินค้า" },
  { label: "20) จำไม่ได้ว่าเคยสั่ง", value: "จำไม่ได้ว่าเคยสั่ง" },
  { label: "ไม่ระบุ", value: "ไม่ระบุ" },
];

// ─── Result values ที่ต้องการ Reason ─────────────────────────────────────────
export const REASON_REQUIRED_RESULTS = new Set([
  "ไม่สนใจ_(ระบุสาเหตุ)",
  "ไม่สนใจ_ห้ามติดต่ออีก(ระบุสาเหตุ)",
]);
